import React, { PureComponent } from 'react';
import { Dropdown, Menu, Button } from 'semantic-ui-react';
import moment from 'moment';

function range(start, end) {
  if (start === end) return [start];
  return [start, ...range(start + 1, end)];
}

const monthList = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export default class AnalysisDateMenu extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeItem: 'MTD',
      yrInit: null,
      yrFinal: null,
      mthInit: null,
      mthFinal: null,
      dataType: 'MTD',
    };
  }

  handleChangeDate = (event, { name, value }) => {
    if (this.state.hasOwnProperty(name)) {
      this.setState({ [name]: value });
    }
  };

  setActiveItem = name => {
    let newState = {};
    if (name === 'MTD') {
      newState = {
        yrInit: null,
        yrFinal: null,
        mthInit: null,
        mthFinal: null,
        dataType: 'MTD',
        activeItem: name,
      };
    } else if (name === 'All') {
      var monthFinal = moment().format('MMMM');
      var yearFinal = moment().format('YYYY');
      newState = {
        yrInit: 2018,
        yrFinal: parseInt(yearFinal),
        mthInit: 'September',
        mthFinal: monthFinal,
        dataType: 'MONTHLY',
        activeItem: name,
      };
    }
    this.setState(newState, () => this.updateDates());
  };

  handleItemClick = (e, { name }) => {
    this.setActiveItem(name);
  };

  getYearOptions = yrInit => {
    if (!yrInit) {
      yrInit = 2018;
    }
    let current_year = moment().format('YYYY');
    let yr_list = range(yrInit, parseInt(current_year));
    return yr_list;
  };

  getMonthOptions = (yrInit, mthInit, yrFinal) => {
    let current_month_idx = parseInt(moment().format('M'));
    let current_year = parseInt(moment().format('YYYY'));
    let mth_idx_list;
    if (yrInit && yrFinal && mthInit) {
      if (yrFinal === yrInit) {
        let mth_idx = monthList.indexOf(mthInit);
        if (yrInit === current_year) {
          mth_idx_list = range(mth_idx, current_month_idx);
        } else {
          mth_idx_list = range(mth_idx, 11);
        }
      } else {
        mth_idx_list = range(0, current_month_idx);
      }
    } else {
      mth_idx_list = range(0, monthList.length);
    }
    let mth_list = mth_idx_list.map(idx => monthList[idx]);
    return mth_list;
  };

  getDropdownOptions(primObjectList) {
    let optionList = primObjectList.map(obj => ({
      key: obj,
      value: obj,
      text: obj,
    }));
    return optionList;
  }

  updateDates = () => {
    const { yrInit, yrFinal, mthInit, mthFinal, dataType } = this.state;
    const { onUpdate } = this.props;
    onUpdate(yrInit, yrFinal, mthInit, mthFinal, dataType);
  };

  render() {
    const { yrInit, yrFinal, mthInit, mthFinal, activeItem } = this.state;
    return (
      <Menu>
        <Menu.Menu position="left">
          <Menu.Item>Period of Analysis</Menu.Item>
          <Menu.Item>
            <Dropdown
              name="yrInit"
              style={{ minWidth: '6em' }}
              placeholder="Initial Year"
              search
              selection
              value={yrInit}
              options={this.getDropdownOptions(this.getYearOptions())}
              onChange={this.handleChangeDate}
            />
            <Dropdown
              width={5}
              style={{ minWidth: '10em' }}
              name="mthInit"
              placeholder="Initial Month"
              search
              selection
              value={mthInit}
              options={this.getDropdownOptions(this.getMonthOptions())}
              onChange={this.handleChangeDate}
            />
            <Dropdown
              name="yrFinal"
              style={{ minWidth: '6em' }}
              width={3}
              placeholder="Final Year"
              search
              value={yrFinal}
              selection
              options={this.getDropdownOptions(this.getYearOptions(yrInit))}
              onChange={this.handleChangeDate}
            />
            <Dropdown
              name="mthFinal"
              style={{ minWidth: '10em' }}
              width={5}
              placeholder="Final Month"
              value={mthFinal}
              search
              selection
              options={this.getDropdownOptions(
                this.getMonthOptions(yrInit, mthInit, yrFinal),
              )}
              onChange={this.handleChangeDate}
            />
            <Button
              compact
              color={'teal'}
              onClick={this.updateDates}
              content={'Update'}
            />
          </Menu.Item>
        </Menu.Menu>
        <Menu.Menu position="right">
          <Menu.Item
            name="All"
            active={activeItem === 'All'}
            onClick={this.handleItemClick}
          >
            All
          </Menu.Item>
          <Menu.Item
            name="MTD"
            active={activeItem === 'MTD'}
            onClick={this.handleItemClick}
          >
            MTD
          </Menu.Item>
        </Menu.Menu>
      </Menu>
    );
  }
}
